<template>
  <b-img :src="iconSrc" @click="onClick" :class="cssClass"></b-img>
</template>

<script>
export default {
  name: 'CustomIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    cssClass: {
      type: String,
    },
  },
  computed: {
    iconSrc() {
      if (!this.icon) {
        return '';
      }
      return require('@/assets/images/icons/' + this.icon + '.svg');
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
  .icon-white {
    filter: brightness(0) invert(1);
  }
</style>
